export const getAdConfig = (adType) => {
  let gptConf = {}
  if (adType === 'web') {
    gptConf = adConfig.gpt_conf
  }
  if (adType === 'app') {
    gptConf = appAdConfig.gpt_conf
  }
  if (adType === 'appRadar') {
    gptConf = appRadarAdConfig.gpt_conf
  }

  return {
    gptConf,
    usePrebids: true,
    lazyload: true
  }
}
